//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import EventBus from '~/eventBus'
import routes from '~/config/routes'

export default {
    name: 'AppHeader',

    props: ['show'],

    data(){ return {
        routes,
        toolbarStyle: {
            minHeight: "60px",
            backgroundColor: '',
        },
        toolbarClass: 'bg-grey-10 text-white',
    }},

    mounted(){

    },

    computed: {
        user(){ return this.$store.getters['auth/user'] },
        userImage(){ return this.user.avatar ? this.user.avatar : 'https://cdn.quasar.dev/img/boy-avatar.png' }
    },

    methods: {
        triggerMenuClick(){
            EventBus.$emit('leftMenuClick')
        },

        logout(){
            this.$store.dispatch('auth/logout')
        },

        login(){
            let href = window.location.href
            let auth = this.$root.config.api.login
            let go = auth + '?cb=' + href

            window.location = go
        }
    }
}
